module.exports = __webpack_public_path__ + "static/media/biz-manager_320.c85639c6.jpg";